import React from "react";
import { Users } from "lucide-react";
import { IOwnerPropertyOption, ISubAccount } from "./types";
import SubAccountCard from "./SubAccountCard";

interface SubAccountListProps {
  accounts: ISubAccount[];
  properties: IOwnerPropertyOption[];
  isUpdating: boolean;
  onEdit: (account: ISubAccount) => void;
  onToggleActive: (account: ISubAccount) => void;
  onDelete: (account: ISubAccount) => void;
}

export default function SubAccountList({
  accounts,
  properties,
  isUpdating,
  onEdit,
  onToggleActive,
  onDelete,
}: SubAccountListProps) {
  if (accounts.length === 0) {
    return (
      <div className="flex flex-col items-center gap-3 rounded-2xl border border-dashed border-[#CBD5E1] bg-[#F8FAFC] px-6 py-10 text-center">
        <Users className="h-8 w-8 text-[#DD6435]" />
        <div>
          <h3 className="text-base font-bold text-[#2D3748]">Nenhum acesso criado</h3>
          <p className="mt-1 text-sm text-[#64748B]">
            Cadastre e-mails da equipe para liberar o painel em imóveis específicos.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {accounts.map((account) => (
        <SubAccountCard
          key={account.id}
          account={account}
          properties={properties}
          isUpdating={isUpdating}
          onEdit={onEdit}
          onToggleActive={onToggleActive}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
